import { SMSTemplatesManager } from '../sms/sms_template_manager';
import { Button as SellerButton } from '../seller-toolbar/toolbar_button';
import { tracking, _t } from '@bark/bark-core';
import {
	cfbAddCopyToClipboardButton,
	cfbRemoveCopyToClipboardButton,
	cfbBindCopyToClipboardButtonListener,
	cfbDisplayShowNumberLink,
	cfbResetDisplayShowNumberLink,
	cfbDisplayPhoneNumberOnMobileButton,
	cfbLeadsPageAddCallButtons,
} from '../call-feedback/call_feedback';
import CallFeedbackModal from '../call-feedback/call_feedback_modal';
import moment from 'moment';
import { addWhatsappResponseButton } from '../whatsapp/whatsapp_response';
import WhatsappResponseFeedbackModal from '../whatsapp/whatsapp_response_feedback_modal';
import {
    shouldShowLeadDetailsNewDesign,
    applyLeadDetailsNewDesignResponseFlowChanges
} from './lead_details_redesign';

export function SellerResponseFlow() {
	let Bark = (window.Bark = window.Bark || {});

	const { document, Handlebars } = window;
	const SMSTemplates = new SMSTemplatesManager();
	window.Bark.SMSTemplates = SMSTemplates;

	const SellerResponseFlowButtonTemplate = Handlebars.compile(
		document.getElementById('seller-response-flow-button-template').innerHTML,
	);
	const SellerResponseFlowLinkTemplate = Handlebars.compile(
		document.getElementById('seller-response-flow-link-button-template').innerHTML,
	);

	const callFeedbackModal = CallFeedbackModal();
	const whatsappResponseFeedbackModal = WhatsappResponseFeedbackModal();

	Bark.sellerResponseFlow = {
		buttonCall: null,
		buttonSendEstimate: null,
		buttonSendSms: null,
		linkSendCustomSMS: null,
		buttonSendTemplateSMS: null,
		buttonSendCustomEmail: null,
		buttonSendTemplateEmail: null,
		buyerUserId: null,
		buyerName: null,
		buyerSupportedSmsType: null,
		dashboardEmailTemplates: null,
		linkSendCustomEmail: null,
		projectId: null,
		projectResponseId: null,
		sellerHasTemplates: false,
		smsData: {
			buyerName: '',
			buyerPhone: '',
			smsType: 'none',
			projectResponseId: null,
		},
		projectCreated: '',
		categoryName: '',

		closeProject() {
			const nextProjectIdToShow = $('div.dashboard-projects-item')
				.not('div[data-project-id="' + this.projectId + '"]')
				.not('div[data-project-id=""]')
				.first()
				.attr('data-project-id');

			// Hide the project details panel
			if (Bark.seller.getNumberOfVisibleProjects() == 0) {
				$('.seller-dash-v2 .dashboard-project-details').fadeOut({ duration: 100 });
			}

			// On mobile just hide the project
			if (Bark.seller.isMobile || !nextProjectIdToShow) {
				Bark.seller.hideProject();
			}
			// On desktop / tablet show the next project on the list, if there is
			else if (nextProjectIdToShow) {
				Bark.seller.showProject(nextProjectIdToShow);
			}
			this.resetStatus();
		},

		/**
		 * Marks a task row complete, and hides the "Finish later" link if all tasks are complete
		 * @param task
		 * @returns {object} A reference to the Bark.sellerResponseFlow
		 */
		completeTask(task) {
			const completedRow = $(`.response-flow-row-${task}`);
			// Mark the row as complete
			completedRow.addClass('completed');
			// If all tasks are complete, hide the skip link
			if (!$(".response-flow-container .response-flow-row:not('.completed')").length) {
				$('.response-flow-footer').addClass('completed');
			} else {
				// Activate the next incomplete row
				const nextIncompleteRows = completedRow.nextAll(':not(.completed)');
				if (nextIncompleteRows) {
					completedRow.removeClass('active');
					nextIncompleteRows.eq(0).addClass('active');
				}
			}
			return Bark.sellerResponseFlow;
		},

		initButtons() {
			Bark.sellerResponseFlow.buttonSendTemplateEmail = new SellerButton({
				name: 'seller-send-template-email',
				// icon: 'test3',
				template: SellerResponseFlowButtonTemplate,
				label: _t('seller_response_flow:send-email.use-email-template-label'),
				params: {},
				callback: () => {
					// Bark.sellerResponseFlow.completeTask('email');
					let { projectId } = document.getElementById(
						'dashboard-project-details',
					).dataset;
					let buyerName = $('.project-details-project-container .buyer_name')
						.first()
						.text();
					Bark.sellerResponseFlow.dashboardEmailTemplates.setProjectData(
						projectId,
						buyerName,
					);
					Bark.sellerResponseFlow.dashboardEmailTemplates.handleSendEmailClick();
					tracking('seller-leads-dashboard-&-responses', 'Send template email', {
						pagename: window.location.pathname,
						project_id: Bark.sellerResponseFlow.projectId,
						project_response_id: Bark.sellerResponseFlow.projectResponseId,
						lead_type: 'project',
					});
				},
				conditions: [
					() => {
						return Bark.sellerResponseFlow.sellerHasTemplates;
					},
				],
				container_class: 'response-button-send-template-email-container',
			});
			Bark.sellerResponseFlow.buttonSendTemplateEmail.render();

			Bark.sellerResponseFlow.buttonSendCustomEmail = new SellerButton({
				name: 'seller-send-custom-email',
				// icon: 'test3',
				template: SellerResponseFlowButtonTemplate,
				label: _t('seller_response_flow:send-email.title'),
				params: {},
				callback: () => {
					// Bark.sellerResponseFlow.completeTask('email');
					let { projectId } = document.getElementById(
						'dashboard-project-details',
					).dataset;
					let buyerName = $('.project-details-project-container .buyer_name')
						.first()
						.text();
					Bark.sellerResponseFlow.dashboardEmailTemplates.setProjectData(
						projectId,
						buyerName,
					);
					Bark.sellerResponseFlow.dashboardEmailTemplates.handleSendCustomEmailClick();
					tracking('seller-leads-dashboard-&-responses', 'Send custom email', {
						pagename: window.location.pathname,
						project_id: Bark.sellerResponseFlow.projectId,
						project_response_id: Bark.sellerResponseFlow.projectResponseId,
						lead_type: 'project',
					});
				},
				conditions: [
					() => {
						return !Bark.sellerResponseFlow.sellerHasTemplates;
					},
				],
				container_class: 'response-button-send-custom-email-container',
			});
			Bark.sellerResponseFlow.buttonSendCustomEmail.render();

			Bark.sellerResponseFlow.linkSendCustomEmail = new SellerButton({
				name: 'seller-send-custom-email-link',
				// icon: 'test3',
				template: SellerResponseFlowLinkTemplate,
				label: _t('seller_response_flow:send-email.send-custom-email-label'),
				params: {},
				callback: () => {
					// Bark.sellerResponseFlow.completeTask('email');
					let { projectId } = document.getElementById(
						'dashboard-project-details',
					).dataset;
					let buyerName = $('.project-details-project-container .buyer_name')
						.first()
						.text();
					Bark.sellerResponseFlow.dashboardEmailTemplates.setProjectData(
						projectId,
						buyerName,
					);
					Bark.sellerResponseFlow.dashboardEmailTemplates.handleSendCustomEmailClick();
					tracking('seller-leads-dashboard-&-responses', 'Send custom email', {
						pagename: window.location.pathname,
						project_id: Bark.sellerResponseFlow.projectId,
						project_response_id: Bark.sellerResponseFlow.projectResponseId,
						lead_type: 'project',
					});
				},
				conditions: [
					() => {
						return Bark.sellerResponseFlow.sellerHasTemplates;
					},
				],
				container_class: 'response-link-send-custom-email-container',
			});
			Bark.sellerResponseFlow.linkSendCustomEmail.render();

			Bark.sellerResponseFlow.buttonSendEstimate = new SellerButton({
				name: 'seller-send-estimate',
				// icon: 'test3',
				template: SellerResponseFlowButtonTemplate,
				label: _t('seller_response_flow:estimate.send-estimate-label'),
				params: {},
				callback: () => {
					Bark.sendEstimate.showModal();
				},
				conditions: [() => true],
				container_class: 'response-button-send-estimate-container',
			});
			Bark.sellerResponseFlow.buttonSendEstimate.render();

			Bark.sellerResponseFlow.buttonSendTemplateSMS = new SellerButton({
				name: 'seller-send-template-sms',
				// icon: 'test3',
				template: SellerResponseFlowButtonTemplate,
				label: _t('seller_response_flow:sms.use-sms-template-label'),
				params: {},
				callback: () => {
					SMSTemplates.loadTemplatePickerModal(Bark.sellerResponseFlow.smsData, () => {
						tracking(
							'seller-leads-dashboard-&-responses',
							'Send template SMS - success',
							{
								pagename: window.location.pathname,
								project_id: Bark.sellerResponseFlow.projectId,
								project_response_id: Bark.sellerResponseFlow.projectResponseId,
								lead_type: 'project',
							},
						);
					});
					tracking('seller-leads-dashboard-&-responses', 'Send template SMS - view', {
						pagename: window.location.pathname,
						project_id: Bark.sellerResponseFlow.projectId,
						project_response_id: Bark.sellerResponseFlow.projectResponseId,
						lead_type: 'project',
					});
				},
				conditions: [
					() => SMSTemplates.hasTemplates(),
					() => Bark.sellerResponseFlow.smsData.smsType === 'api',
				],
				container_class: 'response-button-send-template-sms-container',
			});
			Bark.sellerResponseFlow.buttonSendTemplateSMS.render();

			Bark.sellerResponseFlow.buttonSendSms = new SellerButton({
				name: 'seller-send-sms',
				// icon: 'test3',
				template: SellerResponseFlowButtonTemplate,
				label: _t('seller_response_flow:sms.send-sms-label'),
				params: {},
				callback: () => {
					if (Bark.sellerResponseFlow.smsData.smsType === 'manual') {
						SMSTemplates.loadManualSMSModal(
							Bark.sellerResponseFlow.smsData,
							function () {
								Bark.sellerResponseFlow.recordResponseContact('sms');
								Bark.sellerResponseFlow.completeTask('sms');
								Bark.logEvent(
									'sms-buyer',
									'smsed-buyer-manually',
									'seller-response-flow',
								);
								tracking('seller-leads-dashboard-&-responses', 'Send SMS - success', {
									pagename: window.location.pathname,
									project_id: Bark.sellerResponseFlow.projectId,
									project_response_id: Bark.sellerResponseFlow.projectResponseId,
									lead_type: 'project',
								});
							},
							function () {
								Bark.logEvent(
									'sms-buyer',
									'not-smsed-buyer-manually',
									'seller-response-flow',
								);
							},
						);
					} else {
						let customSMS = SMSTemplates.newCustom(Bark.sellerResponseFlow.smsData);
						tracking('seller-leads-dashboard-&-responses', 'Send custom SMS - view', {
							pagename: window.location.pathname,
							project_id: Bark.sellerResponseFlow.projectId,
							project_response_id: Bark.sellerResponseFlow.projectResponseId,
							lead_type: 'project',
						});
						customSMS.loadCustomSMSModal(
							() => {
								tracking(
									'seller-leads-dashboard-&-responses',
									'Send custom SMS - success',
									{
										pagename: window.location.pathname,
										project_id: Bark.sellerResponseFlow.projectId,
										project_response_id: Bark.sellerResponseFlow.projectResponseId,
										lead_type: 'project',
									},
								);
							},
							() => {},
						);
					}
				},
				conditions: [
					() =>
						Bark.sellerResponseFlow.smsData.smsType === 'manual' ||
						!SMSTemplates.hasTemplates(),
					() => Bark.sellerResponseFlow.smsData.smsType !== 'none',
				],
				container_class: 'response-button-send-sms-container',
			});
			Bark.sellerResponseFlow.buttonSendSms.render();

			Bark.sellerResponseFlow.linkSendCustomSMS = new SellerButton({
				name: 'seller-send-custom-sms-link',
				// icon: 'test3',
				template: SellerResponseFlowLinkTemplate,
				label: _t('seller_response_flow:sms.send-custom-sms-label'),
				params: {},
				callback: () => {
					let customSMS = SMSTemplates.newCustom(Bark.sellerResponseFlow.smsData);
					tracking('seller-leads-dashboard-&-responses', 'Send custom SMS - view', {
						pagename: window.location.pathname,
						project_id: Bark.sellerResponseFlow.projectId,
						project_response_id: Bark.sellerResponseFlow.projectResponseId,
						lead_type: 'project',
					});
					customSMS.loadCustomSMSModal(
						() => {
							tracking(
								'seller-leads-dashboard-&-responses',
								'Send custom SMS - success',
								{
									pagename: window.location.pathname,
									project_id: Bark.sellerResponseFlow.projectId,
									project_response_id: Bark.sellerResponseFlow.projectResponseId,
									lead_type: 'project',
								},
							);
						},
						() => {},
					);
				},
				conditions: [
					() => SMSTemplates.hasTemplates(),
					() => Bark.sellerResponseFlow.smsData.smsType === 'api',
				],
				container_class: 'response-link-send-custom-sms-container',
			});
			Bark.sellerResponseFlow.linkSendCustomSMS.render();

			SMSTemplates.on('got_templates', function () {
				Bark.sellerResponseFlow.buttonSendTemplateSMS.redraw();
				Bark.sellerResponseFlow.buttonSendSms.redraw();
				Bark.sellerResponseFlow.linkSendCustomSMS.redraw();
			});

			SMSTemplates.on('sms.custom_sent', function () {
				Bark.sellerResponseFlow.completeTask('sms');
			});
			SMSTemplates.on('sms.template_sent', function () {
				Bark.sellerResponseFlow.completeTask('sms');
			});

			cfbLeadsPageAddCallButtons(callFeedbackModal);

			Bark.sellerResponseFlow.buttonSendWhatsapp = addWhatsappResponseButton(
				whatsappResponseFeedbackModal,
			);
			Bark.sellerResponseFlow.buttonSendWhatsapp.render();
		},

		/**
		 * Various click event handlers
		 */
		initClickHandlers() {
			// Collapsing seller workflow steps
			$('.response-flow-row')
				.on('click', function () {
					const isAlreadyActive = $(this).hasClass('active');
					$('.response-flow-row').removeClass('active');
					!isAlreadyActive && $(this).addClass('active');
				})
				.removeClass('active')
				.eq(0)
				.addClass('active');

			$('.response-flow-footer .response-flow-skip')
				.off('click')
				.on('click', (e) => {
					Bark.sellerResponseFlow.resetStatus();
					Bark.logEvent('skip-response-flow', 'click', 'seller-response-flow');
					let { projectId } = document.getElementById(
						'dashboard-project-details',
					).dataset;
					tracking('seller-leads-dashboard', 'Skip response flow', {
						pagename: window.location.pathname,
						project_id: projectId,
						lead_type: 'project',
					});
					$('.response-flow-later').fadeIn();
					// On mobile, we need to scroll back to the top
					$('.right-panel').animate({ scrollTop: 0 }, 250);
					e.stopPropagation();
					return false;
				});

			$(document).on('click', 'a.js-show-get-hired-tips', (e) => {
				$('#tipsToGetHiredModal').modal('show');
				Bark.logEvent('show-get-hired-tips', 'click', 'seller-response-flow');
				e.stopPropagation();
				return false;
			});

			$('.js-see-more-leads').on('click.close', () => {
				this.closeProject();
			});
		},

		/**
		 * Listen for specific modal events
		 */
		initModals() {
			Bark.callBuyer &&
				Bark.callBuyer.registerSuccessCallback(() => {
					Bark.sellerResponseFlow.recordResponseContact('phone').completeTask('call');
				});

			Bark.sendEstimate &&
				Bark.sendEstimate.registerSuccessCallback((amount) => {
					Bark.sellerResponseFlow.completeTask('estimate');
					Bark.sellerResponseFlow.setEstimateAmount(amount);
					Bark.sellerResponseFlow.buttonSendEstimate.label = _t(
						'seller_response_flow:estimate.update-estimate-button',
					);
					Bark.sellerResponseFlow.buttonSendEstimate.redraw();

					window.modalManager.setBackdrop(true);
					window.modalManager.showSuccessModal(
						_t('seller_response_flow:estimate.estimate-sent'),
						'',
						2,
					);
				});

			// Listen for the email being sent
			$(document)
				.off('email-template-sent')
				.on('email-template-sent', () => {
					Bark.sellerResponseFlow.completeTask('email');

					window.setTimeout(() => {
						window.modalManager.setBackdrop(true);
						window.modalManager.showSuccessModal(
							_t('seller_response_flow:send-email.email-sent-header'),
							'',
							2,
						);
					}, 500);

					tracking('seller-leads-dashboard-&-responses', 'Send email - success', {
						pagename: window.location.pathname,
						project_id: Bark.sellerResponseFlow.projectId,
						project_response_id: Bark.sellerResponseFlow.projectResponseId,
						lead_type: 'project',
					});
				});
		},

		/**
		 * Resets everything when a new lead is selected
		 */
		resetStatus() {
			$('.response-flow-container, .response-flow-footer').slideUp();
			$('.response-flow-footer').removeClass('completed');
			Bark.sellerResponseFlow.projectResponseId = null;
			Bark.sellerResponseFlow.projectId = null;

			// Remove any completion marks, collapse all but the first row on mobile
			$('.response-flow-row')
				.removeClass('completed')
				.removeClass('active')
				.filter(':not(.completed)')
				.eq(0)
				.addClass('active');

			$('.response-flow-later').hide();

			Bark.sellerResponseFlow.smsData.buyerName = Bark.sellerResponseFlow.buyerName;
			Bark.sellerResponseFlow.smsData.smsType =
				Bark.sellerResponseFlow.buyerSupportedSmsType;
			if (QS.hasKey('force-sms-type')) {
				Bark.sellerResponseFlow.smsData.smsType = QS.getValue('force-sms-type');
			}

			// Reset the call buyer modal
			Bark.callBuyer && Bark.callBuyer.resetStatus(Bark.sellerResponseFlow.buyerName);

			// Reset the send estimate modal
			Bark.sendEstimate && Bark.sendEstimate.resetStatus();

			Bark.sellerResponseFlow.sellerHasTemplates = false;

			// reset the buttons
			Bark.sellerResponseFlow.buttonSendTemplateEmail &&
				Bark.sellerResponseFlow.buttonSendTemplateEmail.redraw();
			Bark.sellerResponseFlow.buttonSendCustomEmail &&
				Bark.sellerResponseFlow.buttonSendCustomEmail.redraw();
			Bark.sellerResponseFlow.linkSendCustomEmail &&
				Bark.sellerResponseFlow.linkSendCustomEmail.redraw();
			Bark.sellerResponseFlow.buttonSendEstimate &&
				(Bark.sellerResponseFlow.buttonSendEstimate.label = _t(
					'seller_response_flow:estimate.send-estimate-label',
				)) &&
				Bark.sellerResponseFlow.buttonSendEstimate.redraw();

			//Call feedback - reset
			cfbRemoveCopyToClipboardButton($('.response-button-call-container-mobile-new'));
			cfbResetDisplayShowNumberLink();
			callFeedbackModal.resetState();
			whatsappResponseFeedbackModal.resetState();
			Bark.sellerResponseFlow?.buttonSendWhatsapp?.redraw();
		},

		/**
		 * Records a response contact to the API
		 * @param contactType
		 * @return {object} a reference to the Bark.sellerResponseFlow
		 */
		recordResponseContact(contactType) {
			try {
				Bark.seller.updateResponseContact(
					Bark.sellerResponseFlow.projectResponseId,
					Bark.sellerResponseFlow.projectId,
					contactType,
					1,
				);
			} catch (e) {
				bugsnagClient.notify(e);
			}
			return Bark.sellerResponseFlow;
		},

		/**
		 * Updates the estimate and button text once an estimate has been entered
		 * @param amount
		 */
		setEstimateAmount(amount) {
			$('.response-flow-container .estimate-amount').text(amount);
			$('#barkSendEstimateModal button span.action').text('Update');
		},

		/**
		 * After submitting details or one-click response, show the response flow
		 * @param data The response data from the API
		 * @param isOneClick Whether this is a one-click response
		 */
		showResponseFlow(data, isOneClick = false) {
			const phoneNumber = data.buyerInfo.tel_formatted || data.buyerInfo.tel;

			// Show the specific success messaging
			let mobileTitle = _t('seller_response_flow:confirm.mobile-title'),
				mobileText = _t('seller_response_flow:confirm.mobile-subtitle.text', {
					more_tips_link:
						'<a href="#" class="js-show-get-hired-tips">' +
						_t('seller_response_flow:confirm.mobile-subtitle.more-tips-link') +
						'</a>',
					interpolation: { escapeValue: false },
				}),
				desktopTitle = _t('seller_response_flow:confirm.mobile-title'),
				desktopText = _t('seller_response_flow:confirm.mobile-subtitle.text', {
					more_tips_link:
						'<a href="#" class="js-show-get-hired-tips">' +
						_t('seller_response_flow:confirm.mobile-subtitle.more-tips-link') +
						'</a>',
					interpolation: { escapeValue: false },
				});
			if (data.successMessaging) {
				if (data.successMessaging.mobile) {
					data.successMessaging.mobile.hasOwnProperty('success_title') &&
						(mobileTitle = data.successMessaging.mobile.success_title);
					data.successMessaging.mobile.hasOwnProperty('success_text') &&
						(mobileText = data.successMessaging.mobile.success_text);
				}
				if (data.successMessaging.desktop) {
					data.successMessaging.desktop.hasOwnProperty('success_title') &&
						(desktopTitle = data.successMessaging.desktop.success_title);
					data.successMessaging.desktop.hasOwnProperty('success_text') &&
						(desktopText = data.successMessaging.desktop.success_text);
				}
			}
			mobileText = mobileText.replace(
				'[link:tips]',
				'<a href="#" class="js-show-get-hired-tips">',
			);
			mobileText = mobileText.replace('[endlink]', '</a>');
			desktopText = desktopText.replace(
				'[link:tips]',
				'<a href="#" class="js-show-get-hired-tips">',
			);
			desktopText = desktopText.replace('[endlink]', '</a>');
			$('#success_message_title .mobile-only-inline').html(mobileTitle);
			$('#success_message_title .desktop-only-inline').html(desktopTitle);
			$('#success_message_text .mobile-only-inline').html(mobileText);
			$('#success_message_text .desktop-only-inline').html(desktopText);

			$('.response-flow-container').slideDown();

			if(!shouldShowLeadDetailsNewDesign()){
				$('.response-flow-footer').slideDown();
			}

			Bark.sellerResponseFlow.projectId = data.project_id;
			Bark.sellerResponseFlow.projectResponseId =
				data.response && data.response.id ? data.response.id : data.response_id;
			Bark.sellerResponseFlow.buyerUserId = data.buyerInfo.id;
			Bark.sellerResponseFlow.buyerName = data.buyerInfo.name;
			Bark.sellerResponseFlow.buyerSupportedSmsType = data.buyer_supported_sms_type;
			Bark.sendEstimate &&
				Bark.sendEstimate.resetStatus({
					responseId: Bark.sellerResponseFlow.projectResponseId,
					buyerUserId: Bark.sellerResponseFlow.buyerUserId,
				});
			Bark.sellerResponseFlow.smsData.buyerName = Bark.sellerResponseFlow.buyerName;
			Bark.sellerResponseFlow.smsData.buyerPhone = phoneNumber;
			Bark.sellerResponseFlow.smsData.smsType =
				Bark.sellerResponseFlow.buyerSupportedSmsType;
			if (QS.hasKey('force-sms-type')) {
				Bark.sellerResponseFlow.smsData.smsType = QS.getValue('force-sms-type');
			}
			Bark.sellerResponseFlow.smsData.projectResponseId =
				Bark.sellerResponseFlow.projectResponseId;
			Bark.sellerResponseFlow.buttonSendTemplateSMS.redraw();
			Bark.sellerResponseFlow.buttonSendSms.redraw();
			Bark.sellerResponseFlow.linkSendCustomSMS.redraw();

			if (Bark.sellerResponseFlow.smsData.smsType === 'api') {
				let callback = false;
				if (SMSTemplates.hasTemplates()) {
					callback = function () {
						SMSTemplates.loadTemplatePickerModal(Bark.sellerResponseFlow.smsData, () => {
							tracking(
								'seller-leads-dashboard-&-responses',
								'Send template SMS - success',
								{
									pagename: window.location.pathname,
									project_id: Bark.sellerResponseFlow.projectId,
									project_response_id: Bark.sellerResponseFlow.projectResponseId,
									lead_type: 'project',
								},
							);
						});
						tracking('seller-leads-dashboard-&-responses', 'Send template SMS - view', {
							pagename: window.location.pathname,
							project_id: Bark.sellerResponseFlow.projectId,
							project_response_id: Bark.sellerResponseFlow.projectResponseId,
							lead_type: 'project',
						});
					};
				} else {
					callback = function () {
						let customSMS = SMSTemplates.newCustom(Bark.sellerResponseFlow.smsData);
						tracking('seller-leads-dashboard-&-responses', 'Send custom SMS - view', {
							pagename: window.location.pathname,
							project_id: Bark.sellerResponseFlow.projectId,
							project_response_id: Bark.sellerResponseFlow.projectResponseId,
							lead_type: 'project',
						});
						customSMS.loadCustomSMSModal(
							() => {
								tracking(
									'seller-leads-dashboard-&-responses',
									'Send custom SMS - success',
									{
										pagename: window.location.pathname,
										project_id: Bark.sellerResponseFlow.projectId,
										project_response_id: Bark.sellerResponseFlow.projectResponseId,
										lead_type: 'project',
									},
								);
							},
							() => {},
						);
					};
				}
			}

			Bark.callBuyer &&
				Bark.callBuyer.resetStatus(Bark.sellerResponseFlow.buyerName, phoneNumber);

			// Hide the "call" row if the buyer has no telephone
			if (phoneNumber && phoneNumber.length) {
				$('.response-flow-row-call').addClass('d-flex').removeClass('d-none');
			} else {
				$('.response-flow-row-call').removeClass('d-flex').addClass('d-none completed');
			}

			// Hide the "sms" row if the buyer cannot be SMSed
			if (['api', 'manual'].indexOf(Bark.sellerResponseFlow.smsData.smsType) > -1) {
				$('.response-flow-row-sms').addClass('d-flex').removeClass('d-none');
			} else {
				$('.response-flow-row-sms').removeClass('d-flex').addClass('d-none completed');
			}

			// Show the correct email button and text
			Bark.sellerResponseFlow.sellerHasTemplates = data.has_templates;
			Bark.sellerResponseFlow.buttonSendTemplateEmail &&
				Bark.sellerResponseFlow.buttonSendTemplateEmail.redraw();
			Bark.sellerResponseFlow.buttonSendCustomEmail &&
				Bark.sellerResponseFlow.buttonSendCustomEmail.redraw();
			Bark.sellerResponseFlow.linkSendCustomEmail &&
				Bark.sellerResponseFlow.linkSendCustomEmail.redraw();
			$('.response-flow-row-email .row-subtext').text(
				Bark.sellerResponseFlow.sellerHasTemplates
					? _t('seller_response_flow:send-email.introduce-yourself-with-custom-email')
					: _t('seller_response_flow:send-email.introduce-yourself'),
			);

			// do the same for the sms
			Bark.sellerResponseFlow.buttonSendTemplateSMS &&
				Bark.sellerResponseFlow.buttonSendTemplateSMS.redraw();
			Bark.sellerResponseFlow.buttonSendSms &&
				Bark.sellerResponseFlow.buttonSendSms.redraw();
			Bark.sellerResponseFlow.linkSendCustomSMS &&
				Bark.sellerResponseFlow.linkSendCustomSMS.redraw();

			// If this was a one-click response, pre-tick the email row
			if (isOneClick) {
				Bark.sellerResponseFlow.completeTask('email');
			}

			// On mobile, go to the first incomplete item. If this was a one-click response, the email step would be completed.
			$('.response-flow-row')
				.removeClass('active')
				.filter(':not(.completed)')
				.eq(0)
				.addClass('active');

			//Call feedback updates
			cfbRemoveCopyToClipboardButton($('.response-button-call-container-mobile-new'));
			cfbResetDisplayShowNumberLink();
			callFeedbackModal.resetState();

			if (data.buyerInfo.tel) {
				let cfbData = {
					buyerName: data.buyerInfo.name,
					buyerNumber: data.buyerInfo.tel,
					projectResponseId: data.response.id,
					projectCreated: Bark.sellerResponseFlow?.projectCreated
						? moment.unix(Bark.sellerResponseFlow.projectCreated).utc().fromNow()
						: '',
					categoryName: Bark.sellerResponseFlow.categoryName,
					project_id: data?.project_id
				};

				cfbAddCopyToClipboardButton($('.response-button-call-container-mobile-new'));
				cfbBindCopyToClipboardButtonListener(
					$('.response-button-call-container-mobile-new'),
					cfbData,
				);

				cfbDisplayPhoneNumberOnMobileButton(
					$('#seller-button-seller-call-mobile-new'),
					$('#seller-button-seller-call-mobile-new span.label.d-md-none'),
					cfbData.buyerNumber,
				);

				cfbDisplayShowNumberLink();
				cfbData.booking_id = QS.getValue('cbid', null);
				cfbData.seller_call_feedback_sms = QS.getValue('sbfbm', null) == 1 ? true : false;

				callFeedbackModal.setInState(cfbData);
				callFeedbackModal.bindShowNumberLinkListener();
			}

			tracking(
				'seller-leads-dashboard-&-responses',
				'responses CTAs - viewed',
				{
					seller_profile_id: Bark?.seller?.id,
					project_id: data.project_id,
					response_id: data.response.id,
					page: window.location.pathname,
				},
			);

			// Hide the "whatsapp" row if buyer has no formatted phone number or cannot be SMSed
			whatsappResponseFeedbackModal.resetState();
			if (
				data.buyerInfo.tel_formatted &&
				data.buyerInfo.tel_formatted.length &&
				['api', 'manual'].includes(Bark.sellerResponseFlow.smsData.smsType)
			) {
				$('.response-flow-row-whatsapp').addClass('d-flex').removeClass('d-none');
				whatsappResponseFeedbackModal.setInState({
					projectId: data.project_id,
					sellerProfileId: Bark?.seller?.id,
					projectResponseId: data.response.id,
					buyerName: data.buyerInfo.name,
					buyerNumberFormatted: data.buyerInfo.tel_formatted,
				});
				Bark.sellerResponseFlow?.buttonSendWhatsapp?.redraw();
			} else {
				$('.response-flow-row-whatsapp')
					.removeClass('d-flex')
					.addClass('d-none completed');
			}

			if(shouldShowLeadDetailsNewDesign()){
				applyLeadDetailsNewDesignResponseFlowChanges(data?.buyerInfo?.name);
			}
		},
	};

	$(document).ready(() => {
		SMSTemplates.refresh();
		Bark.sellerResponseFlow.initClickHandlers();
		Bark.sellerResponseFlow.initModals();
		Bark.sellerResponseFlow.resetStatus();
		Bark.sellerResponseFlow.initButtons();
		Bark.sellerResponseFlow.dashboardEmailTemplates = new Bark.DashboardEmailTemplates();
		Bark.sellerResponseFlow.dashboardEmailTemplates.init();
	});
}
